// Random quote rotator — picks one quote from a `#random-quote` wrapper on
// load and discards the rest, so each page view shows a single random quote.
// The quotes themselves live in `inc/random-quotes.html`, which is included
// wherever a `#random-quote` element appears.

export function mountRandomQuote(): void {
  const randomQuoteWrapper = document.querySelector<HTMLDivElement>("#random-quote");
  if (!randomQuoteWrapper) {
    return;
  }

  const quotes = Array.from(randomQuoteWrapper.children).filter(
    (el): el is HTMLElement => el.classList.contains("random-quote"),
  );
  // Each entry is either a `<template>` (clone its `.content`) or any other
  // `.random-quote` element (clone it directly). Using real nodes for every
  // slot — instead of `null` placeholders for the visible ones — guarantees
  // a replacement always lands in the wrapper, even if the chosen entry is
  // the originally visible quote.
  const pool: Element[] = quotes.map(quote =>
    quote instanceof HTMLTemplateElement ? quote : quote.cloneNode(true) as Element,
  );
  if (pool.length === 0) {
    return;
  }

  const chosen = pool[Math.floor(Math.random() * pool.length)];
  quotes.forEach(quote => quote.remove());
  randomQuoteWrapper.appendChild(
    chosen instanceof HTMLTemplateElement ? chosen.content.cloneNode(true) : chosen,
  );
}
